"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferAssetsForm = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-prototype-builtins */
const react_1 = __importDefault(require("react"));
const antd_1 = require("antd");
const uuid = __importStar(require("uuid"));
const use_offer_notifications_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/use-offer-notifications");
const types_1 = require("@src/types");
const offer_context_1 = require("@src/components/pages/admin/modules/offer-create-or-edit/offer-context");
const offer_asset_gallery_1 = require("./offer-asset-gallery");
const TitleGalleryInfoModal_1 = require("./TitleGalleryInfoModal");
const OfferAssetLibrarySelectionModal_1 = require("./OfferAssetLibrarySelectionModal");
const AddOfferAssetGalleryButton_1 = require("./AddOfferAssetGalleryButton");
const DeleteGalleryModal_1 = require("./DeleteGalleryModal");
function getEmptyOfferGallery() {
    return {
        [types_1.EOfferGalleryKey.title]: '',
        [types_1.EOfferGalleryKey.isTitleGallery]: false,
        [types_1.EOfferGalleryKey.uuid]: uuid.v4(),
        [types_1.EOfferGalleryKey.assets]: [],
    };
}
function getIsGalleryChanged(gallery) {
    if (!gallery) {
        return false;
    }
    return (Boolean(gallery[types_1.EOfferGalleryKey.title]) ||
        gallery[types_1.EOfferGalleryKey.isTitleGallery] ||
        Boolean(gallery[types_1.EOfferGalleryKey.assets].length));
}
exports.OfferAssetsForm = react_1.default.forwardRef(({ offerAssetsInitialValues }, ref) => {
    const [form] = antd_1.Form.useForm();
    const setOfferAssetsValuesInContext = (0, offer_context_1.useOfferContextValueSelector)(v => v.offer.assets.setValues);
    const setValuesInContextAndForm = (newValues) => {
        form.setFieldsValue(newValues);
        setOfferAssetsValuesInContext(newValues);
    };
    const [isTitleGalleryInfoModalOpen, setIsTitleGalleryInfoModalOpen] = react_1.default.useState(false);
    const [isAssetLibrarySelectionModalOpen, setIsAssetLibrarySelectionModalOpen] = react_1.default.useState(false);
    const [assetSelectionGalleryUuid, setAssetSelectionGalleryUuid] = react_1.default.useState(null);
    const [galleryToDeleteUuid, setGalleryToDeleteUuid] = react_1.default.useState(null);
    const { showTitleGalleryChangedNotification } = (0, use_offer_notifications_1.useOfferNotifications)();
    const setNewTitleGallery = (newTitleGalleryIndex) => {
        const currentValues = form.getFieldsValue();
        setValuesInContextAndForm({
            ...currentValues,
            [types_1.EOfferAssetsFormField.galleries]: currentValues[types_1.EOfferAssetsFormField.galleries].map((gal, index) => index === newTitleGalleryIndex ? { ...gal, isTitleGallery: true } : { ...gal, isTitleGallery: false }),
        });
    };
    const setGalleryAssets = async (assets) => {
        const currentValues = form.getFieldsValue();
        setValuesInContextAndForm({
            ...currentValues,
            [types_1.EOfferAssetsFormField.galleries]: currentValues[types_1.EOfferAssetsFormField.galleries].map(gal => gal.uuid === assetSelectionGalleryUuid ? { ...gal, [types_1.EOfferGalleryKey.assets]: assets } : gal),
        });
    };
    const getIsChangingTitleGallery = (changedGalleries) => {
        if (!changedGalleries) {
            return false;
        }
        const changedGalleriesKeys = Object.keys(changedGalleries);
        if (changedGalleriesKeys.length !== 1) {
            return false;
        }
        const changedGallery = changedGalleries[changedGalleriesKeys[0]];
        if (!changedGallery) {
            return false;
        }
        const changedGalleryKeys = Object.keys(changedGallery);
        return (changedGalleryKeys.length === 1 &&
            changedGallery.hasOwnProperty(types_1.EOfferGalleryKey.isTitleGallery) &&
            changedGallery[types_1.EOfferGalleryKey.isTitleGallery] === true);
    };
    const handleValuesChanges = (changedValues) => {
        const changedGalleries = changedValues[types_1.EOfferAssetsFormField.galleries];
        const isChangingTitleGallery = getIsChangingTitleGallery(changedGalleries || null);
        if (isChangingTitleGallery) {
            const newTitleGalleryIndex = changedGalleries.findIndex(gal => gal && gal[types_1.EOfferGalleryKey.isTitleGallery] === true);
            setNewTitleGallery(newTitleGalleryIndex);
            showTitleGalleryChangedNotification();
        }
        setOfferAssetsValuesInContext(form.getFieldsValue());
    };
    react_1.default.useEffect(() => {
        // Synchronize context also on unmount
        // Just in case last change to form was made with form.setFieldsValues and didnt trigger handleFormValuesChange
        return () => {
            setOfferAssetsValuesInContext(form.getFieldsValue());
        };
    }, []);
    const validateFormAndGetResult = async () => {
        try {
            await form.validateFields();
            return true;
        }
        catch (_a) {
            const fstErrorField = form.getFieldsError().find(({ errors }) => errors.length > 0);
            form.scrollToField(fstErrorField.name, { behavior: 'smooth', block: 'center' });
            return false;
        }
    };
    react_1.default.useImperativeHandle(ref, () => ({ validateFormAndGetResult }));
    const getOfferGalleryAssetIds = (galleryUuid) => {
        if (!galleryUuid) {
            return null;
        }
        const gallery = form.getFieldValue(types_1.EOfferAssetsFormField.galleries).find(gal => gal.uuid === galleryUuid);
        return gallery[types_1.EOfferGalleryKey.assets].map(asset => asset.id);
    };
    const removeGallery = (galleryUuid) => {
        const currentValues = form.getFieldsValue();
        setValuesInContextAndForm({
            ...currentValues,
            [types_1.EOfferAssetsFormField.galleries]: currentValues[types_1.EOfferAssetsFormField.galleries].filter(gal => gal.uuid && gal.uuid !== galleryUuid),
        });
        setGalleryToDeleteUuid(null);
    };
    const onAssetsDelete = (deletedAssetIds) => {
        var _a;
        const currentValues = form.getFieldsValue();
        setValuesInContextAndForm({
            ...currentValues,
            [types_1.EOfferAssetsFormField.galleries]: (_a = currentValues[types_1.EOfferAssetsFormField.galleries]) === null || _a === void 0 ? void 0 : _a.map(gallery => ({
                ...gallery,
                assets: gallery.assets.filter(ass => !deletedAssetIds.includes(ass.id)),
            })),
        });
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form, { form: form, initialValues: offerAssetsInitialValues, layout: "vertical", onValuesChange: handleValuesChanges, children: (0, jsx_runtime_1.jsx)(antd_1.Form.List, { name: types_1.EOfferAssetsFormField.galleries, children: (fields, { add }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [fields.map(field => {
                                return ((0, jsx_runtime_1.jsx)(offer_asset_gallery_1.OfferAssetGallery, { fieldName: field.name, openTitleGalleryInfoModal: () => setIsTitleGalleryInfoModalOpen(true), removeThisGallery: () => {
                                        const gallery = form.getFieldValue(types_1.EOfferAssetsFormField.galleries)[field.name];
                                        const isGalleryChanged = getIsGalleryChanged(gallery || null);
                                        if (isGalleryChanged) {
                                            setGalleryToDeleteUuid(gallery[types_1.EOfferGalleryKey.uuid]);
                                        }
                                        else {
                                            removeGallery(gallery[types_1.EOfferGalleryKey.uuid]);
                                        }
                                    }, openOfferAssetLibrarySelectionModal: () => {
                                        const gallery = form.getFieldValue(types_1.EOfferAssetsFormField.galleries)[field.name];
                                        setIsAssetLibrarySelectionModalOpen(true);
                                        setAssetSelectionGalleryUuid(gallery[types_1.EOfferGalleryKey.uuid]);
                                    } }, field.key));
                            }), (0, jsx_runtime_1.jsx)(AddOfferAssetGalleryButton_1.AddOfferAssetGalleryButton, { addGallery: () => add(getEmptyOfferGallery()) })] })) }) }), (0, jsx_runtime_1.jsx)(TitleGalleryInfoModal_1.TitleGalleryInfoModal, { isOpen: isTitleGalleryInfoModalOpen, closeModal: () => setIsTitleGalleryInfoModalOpen(false) }), (0, jsx_runtime_1.jsx)(OfferAssetLibrarySelectionModal_1.OfferAssetLibrarySelectionModal, { isOpen: isAssetLibrarySelectionModalOpen, setGalleryAssets: setGalleryAssets, galleryAssetIds: getOfferGalleryAssetIds(assetSelectionGalleryUuid), onAssetsDelete: onAssetsDelete, closeModal: () => {
                    setIsAssetLibrarySelectionModalOpen(false);
                    setAssetSelectionGalleryUuid(null);
                } }), (0, jsx_runtime_1.jsx)(DeleteGalleryModal_1.DeleteGalleryModal, { isOpen: Boolean(galleryToDeleteUuid), onOk: () => removeGallery(galleryToDeleteUuid), onCancel: () => setGalleryToDeleteUuid(null) })] }));
});
